import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4e6c662c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "form-container"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "description"
};
const _hoisted_4 = {
  key: 0,
  class: "code-msg"
};
const _hoisted_5 = {
  key: 1
};
import { ref, reactive, onMounted, onUnmounted, inject } from 'vue';
import { getSmsCode, sendCustomInfo } from '@/api/index';
import { message } from 'ant-design-vue';
import { CloseCircleFilled } from '@ant-design/icons-vue'; // CloseCircleOutlined<close-circle-filled />
import { REGEXP } from '@/utils/valid';
import { $track } from '@/plugins/Track';
export default {
  __name: 'index',
  props: {
    mainTitle: String,
    desc: String
  },
  setup(__props) {
    const props = __props;
    const userMsg = ref(null);
    const waitTime = ref(0);
    const width = ref(0);
    const className = ref('');
    const layout = ref('inline');
    const isLoading = ref(false);
    const matchPhone = ref(false);
    const submitSource = inject('submitSource');

    // form data
    const defaultData = {
      customerName: '',
      companyName: '',
      phone: '',
      smsCode: '',
      type: 0,
      submitSource
    };
    const user = reactive({
      ...defaultData
    });

    // 隐藏form表单
    const hiddenForm = () => {
      className.value = 'hide';
    };

    // 获取验证码
    const getCode = async () => {
      try {
        const res = await getSmsCode(user);
        message[res.status === 200 ? 'success' : 'warning'](res.message);
        waitTime.value = 60;
        const timer = setInterval(() => {
          waitTime.value -= 1;
          if (!waitTime.value) {
            clearInterval(timer);
          }
        }, 1000);
      } catch (e) {}
    };

    // post form data
    const onFinish = async () => {
      // 发送成功，点击免费试用，清除表单
      // 验证码错误未弹窗
      try {
        isLoading.value = true;
        sendUserInfo();
        const res = await sendCustomInfo(user);
        isLoading.value = false;
        if (res.status === 200) {
          userMsg.value.resetFields();
          waitTime.value = 0;
          matchPhone.value = false;
          return message.success(res.message);
        }
        return message.error(res.message);
      } catch (e) {
        isLoading.value = false;
      }
    };

    // 修改form 显示
    const changeLayout = () => {
      width.value = document.body.clientWidth;
      const check = width.value <= 768;
      className.value = check ? 'ver-form' : '';
      layout.value = check ? 'horizontal' : 'inline';
    };
    let timer;
    onMounted(() => {
      window.onresize = () => {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(changeLayout, 60);
      };
      changeLayout();
    });
    onUnmounted(() => {
      if (timer) {
        clearTimeout(timer);
        window.onresize = null;
      }
    });

    // 手机号录入成功后上报
    const sendUserMobile = () => {
      if (matchPhone.value) {
        sendUserInfo(false);
      }
    };
    const checkPhone = () => {
      matchPhone.value = user.phone && REGEXP.phone.test(user.phone);
    };

    // 上报用户信息
    const sendUserInfo = (isSubmit = true) => {
      $track('CustomerLeads', {
        leads_user_name: user.customerName,
        leads_corporate_name: user.companyName,
        leads_user_mobile: user.phone,
        leads_source: '官网底部',
        leads_is_submit: isSubmit
      });
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_spin = _resolveComponent("a-spin");
      return _openBlock(), _createBlock(_component_a_spin, {
        spinning: isLoading.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: _normalizeClass(["form", className.value])
        }, [_createElementVNode("div", {
          class: "form-close",
          title: "关闭",
          onClick: _cache[0] || (_cache[0] = $event => hiddenForm())
        }, [_createVNode(_unref(CloseCircleFilled), {
          style: {
            "font-size": "36px"
          }
        })]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(props.mainTitle), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(props.desc), 1), _createVNode(_component_a_form, {
          ref_key: "userMsg",
          ref: userMsg,
          model: user,
          name: "customerName",
          "hide-required-mark": true,
          layout: layout.value,
          onFinish: onFinish
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            class: _normalizeClass(layout.value === 'inline' ? 'min-input' : ''),
            name: "customerName",
            rules: [{
              required: true,
              pattern: _unref(REGEXP).name,
              message: '请输入姓名'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: user.customerName,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => user.customerName = $event),
              placeholder: "请输入姓名"
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["class", "rules"]), _createVNode(_component_a_form_item, {
            class: _normalizeClass(layout.value === 'inline' ? 'max-input' : ''),
            name: "companyName",
            rules: [{
              required: true,
              pattern: _unref(REGEXP).companyName,
              message: '请输入公司名称'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: user.companyName,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => user.companyName = $event),
              placeholder: "请输入公司名称"
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["class", "rules"]), _createVNode(_component_a_form_item, {
            class: _normalizeClass(layout.value === 'inline' ? 'min-input' : ''),
            name: "phone",
            rules: [{
              required: true,
              pattern: _unref(REGEXP).phone,
              message: '请输入手机号码'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: user.phone,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => user.phone = $event),
              onBlur: _cache[4] || (_cache[4] = $event => sendUserMobile()),
              onInput: _cache[5] || (_cache[5] = $event => checkPhone()),
              placeholder: "请输入手机号码"
            }, null, 8, ["value"])]),
            _: 1
          }, 8, ["class", "rules"]), _createVNode(_component_a_form_item, {
            class: _normalizeClass(["code", layout.value === 'inline' ? 'min-input ' : '']),
            name: "smsCode",
            rules: [{
              required: true,
              pattern: _unref(REGEXP).captcha,
              message: '验证码错误'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: user.smsCode,
              "onUpdate:value": _cache[6] || (_cache[6] = $event => user.smsCode = $event),
              placeholder: "请输入验证码"
            }, null, 8, ["value"]), matchPhone.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [!waitTime.value ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "javascript:void(0)",
              onClick: _cache[7] || (_cache[7] = $event => getCode())
            }, "获取验证码")) : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(waitTime.value) + " s", 1))])) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["class", "rules"]), _createVNode(_component_a_form_item, {
            class: "noboder",
            style: {
              "margin-bottom": "16px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit"
            }, {
              default: _withCtx(() => [_createTextVNode("免费试用")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "layout"])])], 2)]),
        _: 1
      }, 8, ["spinning"]);
    };
  }
};